import { Component, OnInit, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { AppSettings } from "projects/portal/src/app.settings";
import { BrandingService, CompanyBranding, SsoAccountFacade, SsoAccountData, SsoAccountType } from "common";
import { MatMenuTrigger } from "@angular/material/menu";
import { UntilDestroy, untilDestroyed } from "@ngneat/until-destroy";

@UntilDestroy()
@Component({
    selector: "ifp-user-menu",
    templateUrl: "./user-menu.component.html",
    standalone: false
})
export class UserMenuComponent implements OnInit {
  @ViewChild(MatMenuTrigger) userMenu: MatMenuTrigger;

  isInWebView: boolean = false;
  allowPasswordUpdate: boolean = false;
  brandingData: CompanyBranding;

  constructor(
    private router: Router,
    private appSettings: AppSettings,
    private ssoAccountFacade: SsoAccountFacade,
    private brandingService: BrandingService
  ) {
    if ((window as any)?.flutter_inappwebview) {
      this.isInWebView = true;
    }
  }

  ngOnInit(): void {
    this.initBranding();
    this.ssoAccountFacade.getCurrentSsoAccount$().pipe(untilDestroyed(this)).subscribe(
      (currentSsoAccount: SsoAccountData) => this.setAllowPasswordUpdate(currentSsoAccount)
    );
  }

  private initBranding() {
    this.brandingService.getBranding$()
      .pipe(untilDestroyed(this))
      .subscribe((branding) => {
        this.brandingData = branding;
      });
  }

  logout(): void {
    this.router.navigate(["/sign-out"]);
  }

  changePassword(): void {
    if (this.isInWebView) {
      this.userMenu.closeMenu();
      (window as any).flutter_inappwebview.callHandler(
        "onChangePasswordSettingsClicked"
      );
    }
    else {
      window.location.href = this.brandingData?.loginUrl + this.appSettings.auth.changePassword + '?redirectUrl=' + this.appSettings.portal.url;
    }
  }

  setBiometric(): void {
    if (this.isInWebView) {
      this.userMenu.closeMenu();
      (window as any).flutter_inappwebview.callHandler(
        "onBiometricsSettingsClicked"
      );
    }
  }

  private setAllowPasswordUpdate(currentSsoAccount: SsoAccountData): void {
    this.allowPasswordUpdate = currentSsoAccount.accountType === SsoAccountType.Internal;
  }
}
